<template>
    <div>
        <div class="background">
          <img src="../assets/img/xycx_bj.png" class="nrbj"/>
          <div class="nrBox">
            <img src="../assets/img/xycx_p.png" class="jsbanner"/>
            <div class="nrMain">
                <div class="tab-content" style="text-align: center">
                    <h1>{{name}}</h1><br/>
                  <span style="font-size: 14px;">{{uscc}}</span>　　
                  <a-button type="primary" @click="showModal" :loading="downSpinning" v-if="account.roleId">
                    {{downText}}
                  </a-button>
                </div>


                      <a-descriptions bordered :column="1">

                        <a-descriptions-item :label="basic.head[index]" v-for="(key,index) in basic.body">
                          {{key}}
                        </a-descriptions-item>
                      </a-descriptions>

              <a-tabs defaultActiveKey="2" style="margin-top: 20px">
                <a-tab-pane :tab="item.title" :key="index" forceRender v-for="(item,index) in list">
                  <!-- 底部所有tab -->
                  <div
                      v-if="item.title !== '金融信用信息' && item.body.length == 0">
                    <template>
                      <a-empty description="查询期内无相关记录"/>
                    </template>
                  </div>
                  <div v-if="item.title == '金融信用信息' && item.body.length == 0">
                    <template>
                      <a-empty description="查询期内无相关记录"/>
                    </template>
                  </div>
                  <a-descriptions style="margin-bottom: 20px"
                                  v-if="item.title !== '其他信息' && item.title !== '金融信用信息'"
                                  bordered :column="1" v-for="(key,index) in item.body">
                    <a-descriptions-item :label="val" v-for="(val,indexHead) in item.head">
                      {{key[indexHead]}}
                    </a-descriptions-item>
                  </a-descriptions>
                  <!-- 其他信息 -->
                  <div v-if="item.title == '其他信息'" v-for="(key,index) in item.body">
                    <p class="mes_nr" style="border:none;font-weight: bold;font-size: 15px;">
                      {{key.title}}</p>
                    <p v-if="key.body.length == 0" class="mes_nr"
                       style="border: none;color: red;width: 100%;">
                      查询期内无相关记录
                    </p>
                    <a-descriptions bordered :column="1" v-for="(bo,indexBody) in key.body"
                                    style="margin-bottom: 20px">
                      <a-descriptions-item :label="val" v-for="(val,indexHead) in key.head">
                        {{bo[indexHead]}}
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                  <!--纳税信息-->
                  <div v-if="item.title == '金融信用信息'" v-for="(val,valIndex) in item.body">
                    <p style="width: 100%;text-align: center;border: none;font-weight: bold;font-size: 15px;"
                       class="mes_nr">{{val.title}}</p>
                    <p v-if="val.body.length == 0" class="mes_nr"
                       style="border: none;color: red;width: 100%;">
                      查询期内无相关记录
                    </p>
                    <p v-else-if="val.body[0] == '查询失败'" class="mes_nr"
                       style="border: none;color: red;width: 100%;">
                      {{val.body[0]}}
                    </p>
                    <a-descriptions v-else bordered :column="1" v-for="(key,indexBody) in val.body"
                                    style="margin-bottom: 20px">
                      <a-descriptions-item :label="head" v-for="(head,headIndex) in val.head">
                        {{key[headIndex]}}
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </div>
          </div>
        </div>

    </div>
</template>

<script>
    import {getDa} from "@/api/search"
    import {userStatus} from "@/api/user"
    import {getReport} from "@/api/self_management/creditArchives";
    import {mapState} from "vuex";

    export default {
      computed: {
        ...mapState(["downPath"]),
      },
        data() {
            return {
                account:{},
                name:"",
              downText: "下载信用档案",
              downSpinning: false,
                uscc:"",
              height:null,
              reportVisible : false,
                basic: {},
                list: [],
                list2: [],
                list3: [],
                list4: [],
                list5: [],
                list6: [],
                list7: [],
                list8: [],
            }
        },
        name: 'detail',
      // beforeCreate() {
      //   this.$message.info("正在查询......可能会比较慢，请耐心等待！", 5);
      // },
      beforeRouteEnter(to, from, next) {
          if(to.query.uscc && to.query.name){
            getDa(to.query.uscc,to.query.name)
                    .then(res => {
                      next(vm => {
                        vm.height = document.body.clientHeight - 90
                        vm.name=to.query.name;
                        vm.uscc=to.query.uscc;
                        vm.$ajaxAfter(res).then(() => {
                          if (res.data.success === 'TRUE') {
                            if (JSON.stringify(res.data.data.result) != "{}") {
                              // console.log(res.data.data.result);
                              vm.basic = res.data.data.result.result.basic;
                              vm.list = res.data.data.result.result.list;
                            } else {
                              vm.reportVisible = false;
                              vm.basic = {};
                              vm.tyshxydm = "123";
                              vm.list = [];
                              vm.list2 = [];
                              vm.list3 = [];
                              vm.list4 = [];
                              vm.list5 = [];
                              vm.list6 = [];
                              vm.list7 = [];
                              vm.list8 = [];
                            }

                          } else {
                            vm.$message.error("无法获取当前登录企业!");
                          }
                        });
                      });
                    })
                    .catch(() => {
                      next(vm => {
                        vm.$message.error("服务器出错！请稍后再试!");
                        vm.$Progress.fail();
                      });
                    });
          }
        },
        mounted() {
            this.getAccount();
        },

        methods: {
            getAccount() {
                userStatus()
                    .then(res => {
                        // console.log("account:", res.data.success)
                        this.account = res.data.data.account;
                    })
            },
          showModal() {
            this.downSpinning = true;
            this.downText = "等待中";
                getReport(this.uscc,this.name).then(res => {
                  this.$ajaxAfter(res).then(() => {
                    if (res.data.success == "TRUE") {
                      this.checkVisible = false;
                      this.confirmLoading = false;
                      let aTag = document.createElement('a');
                      //文件名
                      aTag.download = this.basic.qyName + ".pdf";
                      //下载地址
                      aTag.href = this.downPath + res.data.data.path;
                      aTag.click();
                      this.downSpinning = false;
                      this.downText = "下载信用档案";
                    } else {
                      this.downSpinning = false;
                      this.downText = "下载信用档案";
                      this.$message.error("出错");
                    }
                  })
                }).catch(() => {
                  this.downSpinning = false;
                  this.downText = "下载信用档案";
                  this.$message.error("服务器出错！请稍后再试!");
                });

          },
        }
    };
</script>

<style scoped lang="less">
    * {
        text-align: center;
    }
    .nr_bj{
        width: 100%;
        background-color: #fff;
        min-height: 500px;
    }
    .nr{
        width: 1100px;
        margin: 0 auto;
        padding: 10px 0;
    }

    .nrMain{
      width: 100%;
      background-color: #ffffff;
      padding: 20px;
    }
    .nrbj{
      width: 100%;
      height: 360px;
      position: absolute;
      z-index: 3;
      top: 0;
    }
    .background{
      width: 100%;
      height: 100%;
      background-color: #f5f5f5;
      position: relative;
      z-index: 1;
      margin-top: 102px;
    }
    .nrBox{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      z-index: 5;
      padding-top: 50px;
    }

    .jsbanner{
      display: block;
      width: 684px;
      margin: 0 auto;
      margin-bottom: 30px;
    }
    .mes_table {
        border: solid 1px #d7d7d7;
        margin-top: 10px;
        width: 100%;
    }

    .mes_tr {
        line-height: 35px;
        border-bottom: solid 1px #d7d7d7;
    }

    .mes_tab {
        margin-top: 20px;
    }

    .mes_head {
        line-height: 35px;
        margin-top: 10px;
    }

    .mes_nr {
        line-height: 25px;
        border-left: solid 1px #d7d7d7;
        padding-left: 5px;
    }
</style>
